import store from '../../store/index'

const routes = [
  {
    path: '/tendersure/tender/buyers',
    name: 'QedSourcingTenderBuyers',
    component: () => import('../../views/qed/tender/Buyers.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tenders',
    name: 'QedSourcingTenders',
    component: () => import('../../views/qed/tender/List.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/edit/tender/:id',
    name: 'QedSourcingTender_edit',
    component: () => import('../../views/qed/tender/Edit.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/create/tender',
    name: 'QedSourcingTender_create',
    component: () => import('../../views/qed/tender/Create.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/details/:id',
    name: 'QedSourcingTender_details',
    component: () => import('../../views/qed/tender/Details.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/create/category/:id',
    name: 'QedSourcingTender_category_create',
    component: () => import('../../views/qed/tender/category/Create.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CATEGORY')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/edit/category/:tender_id/:category_id',
    name: 'QedSourcingTender_category_edit',
    component: () => import('../../views/qed/tender/category/Edit.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CATEGORY')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/category/details/:tender_id/:category_id',
    name: 'QedSourcingTender_category_details',
    component: () => import('../../views/qed/tender/category/Details.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CATEGORY')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/category/refresh/scores/:tender_id/:category_id/:task_id',
    name: 'QedSourcingTenderCategoryRefreshScores',
    component: () => import('../../views/qed/tender/category/RefreshScoresProgress.vue')
  },
  {
    path: '/tendersure/tender/preview_questions/:tender_id/:category_id',
    name: 'QedSourcingTender_preview_questions',
    component: () => import('../../views/qed/tender/category/PreviewQuestions.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CATEGORY')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/financial/details/:tender_id/:category_id',
    name: 'QedSourcingTender_financial_details',
    component: () => import('../../views/qed/tender/category/financial/Details.vue')
  },
  {
    path: '/tendersure/tender/create/section/:tender_id/:category_id',
    name: 'QedSourcingTender_create_section',
    component: () => import('../../views/qed/tender/category/section/Create.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CRETERIA')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/edit/section/:tender_id/:category_id/:section_id',
    name: 'QedSourcingTender_edit_section',
    component: () => import('../../views/qed/tender/category/section/Edit.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CRETERIA')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/section/questions/:category_id/:section_id',
    name: 'QedSourcingTender_section_questions',
    component: () => import('../../views/qed/tender/category/section/Questions.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CRETERIA')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/create/question/:section_id',
    name: 'QedSourcingTender_create_question',
    component: () => import('../../views/qed/tender/category/section/CreateQuestion.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CRETERIA')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/edit/question/:section_id/:id',
    name: 'QedSourcingTender_edit_question',
    component: () => import('../../views/qed/tender/category/section/EditQuestion.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CRETERIA')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/qa/instructions/:category_id',
    name: 'QedSourcingTender_qa_instructions',
    component: () => import('../../views/qed/tender/category/qa/AddInstructions.vue')
  },
  {
    path: '/tendersure/tender/conduct/qa/:category_id/:participant_id',
    name: 'QedSourcingTender_conduct_qa',
    component: () => import('../../views/qed/tender/category/qa/ConductQa.vue')
  },
  {
    path: '/tendersure/tender/dd/details/:category_id',
    name: 'QedSourcingTender_dd_details',
    component: () => import('../../views/qed/tender/category/dd/Participants.vue')
  },
  {
    path: '/tendersure/tender/dd/conduct/:category_id/:participant_id/:question_id',
    name: 'QedSourcingTender_dd_conduct',
    component: () => import('../../views/qed/tender/category/dd/ConductDD.vue')
  },
  {
    path: '/tendersure/tender/dd/add/questions/:category_id',
    name: 'QedSourcingTender_dd_add_questions',
    component: () => import('../../views/qed/tender/category/dd/AddDDWideQuestions.vue')
  },
  {
    path: '/tendersure/tender/dd/add/supplier/questions/:category_id/:participant_id',
    name: 'QedSourcingTender_dd_add_supplier_questions',
    component: () => import('../../views/qed/tender/category/dd/AddPerSupplierQuestion.vue')
  },
  {
    path: '/tendersure/tender/dd/supplier/questions/:category_id/:participant_id',
    name: 'QedSourcingTender_dd_supplier_questions',
    component: () => import('../../views/qed/tender/category/dd/SupplierQuestions.vue')
  },
  {
    path: '/tendersure/tender/letters/:job_id/:category_id',
    name: 'QedSourcingTender_letters',
    component: () => import('../../views/qed/tender/category/letters/ParticipantList.vue')
  },
  {
    path: '/tendersure/tender/preview/award/letter/:job_id/:category_id/:supplier_id',
    name: 'QedSourcingTender_preview_award_letter',
    component: () => import('../../views/qed/tender/category/letters/award_letter/PreviewLetter.vue')
  },
  {
    path: '/tendersure/tender/preview/regret/letter/:job_id/:category_id/:supplier_id',
    name: 'QedSourcingTender_preview_regret_letter',
    component: () => import('../../views/qed/tender/category/letters/regret_letter/PreviewLetter.vue')
  },
  {
    path: '/tendersure/tender/reports/:id',
    name: 'QedSourcingTender_reports_details',
    component: () => import('../../views/qed/tender/reports/Details.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'VIEW_REPORT')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/report/progress/:tender_id/:task_id',
    name: 'QedSourcingTender_reports_progress',
    component: () => import('../../views/qed/tender/reports/Progress.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'VIEW_REPORT')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/tender/invited/suppliers/:tender_id/:category_id',
    name: 'QedSourcingTender_invited_suppliers',
    component: () => import('../../views/qed/tender/category/InvitedSuppliers.vue')
  },
    {
    path: '/tendersure/tender/letters/jobs',
    name: 'QedSourcingTenderLetterJobs',
    component: () => import('../../views/qed/tender/category/letters/LetterJobs.vue')
  },
  {
    path: '/tendersure/tender/letters/:job_id',
    name: 'QedSourcingTenderLetterCategories',
    component: () => import('../../views/qed/tender/category/letters/LetterCategories.vue')
  },
  {
    path: '/tendersure/tender/letters/success/create/:job_id',
    name: 'QedSourcingTenderLetterSuccessCreate',
    component: () => import('../../views/qed/tender/category/letters/award_letter/CreateAward.vue')
  },
  {
    path: '/tendersure/tender/letters/success/edit/:job_id',
    name: 'QedSourcingTenderLetterSuccessEdit',
    component: () => import('../../views/qed/tender/category/letters/award_letter/EditAwardLetter.vue')
  },
  {
    path: '/tendersure/tender/letters/custom/create/:job_id',
    name: 'QedSourcingTenderLetterCustomCreate',
    component: () => import('../../views/qed/tender/category/letters/custom/CreateCustom.vue')
  },
    {
    path: '/tendersure/tender/letters/custom/edit/:job_id',
    name: 'QedSourcingTenderLetterCustomEdit',
    component: () => import('../../views/qed/tender/category/letters/custom/EditCustomLetter.vue')
  },
  {
    path: '/tendersure/tender/letters/dd/create/:job_id',
    name: 'QedSourcingTenderLetterDDCreate',
    component: () => import('../../views/qed/tender/category/letters/dd_letter/CreateDD.vue')
  },
  {
    path: '/tendersure/tender/letters/dd/edit/:job_id',
    name: 'QedSourcingTenderLetterDDEdit',
    component: () => import('../../views/qed/tender/category/letters/dd_letter/EditDDLetter.vue')
  },
  {
    path: '/tendersure/tender/letters/regret/create/:job_id',
    name: 'QedSourcingTenderLetterRegretCreate',
    component: () => import('../../views/qed/tender/category/letters/regret_letter/CreateRegret.vue')
  },
  {
    path: '/tendersure/tender/letters/regret/edit/:job_id',
    name: 'QedSourcingTenderLetterRegretEdit',
    component: () => import('../../views/qed/tender/category/letters/regret_letter/EditRegretLetter.vue')
  },
    {
    path: '/tendersure/tender/zip/files/progress/:task_id/:section_id',
    name: 'QedSourcingTenderZipFiles',
    component: () => import('../../views/qed/tender/category/ZipFilesProgress.vue')
  },
    {
    path: '/tendersure/tender/cat/suppliers/progress/:tender_id/:task_id/',
    name: 'QedSourcingTenderCatSuppliers',
    component: () => import('../../views/qed/tender/CatSuppliersProgress.vue')
  },
  {
    path: '/tendersure/tender/question/upload/progress/:tender_id/:task_id',
    name: 'QedSourcingTenderQuestionUploadProgress',
    component: () => import('../../views/qed/tender/QuestionUploadProgress.vue')
  },
]

export default routes;
